import { CURVETIME_EPSILON } from './constant';
export default class CurveLocation {
    constructor(curve, time, point, distance) {
        // Merge intersections very close to the end of a curve with the
        // beginning of the next curve.
        if (time >= 1 - CURVETIME_EPSILON) {
            const next = curve.getNext();
            if (next) {
                time = 0;
                curve = next;
            }
        }
        this.setCurve(curve);
        this.time = time;
        this.point = point || curve.getPointAtTime(time);
        this.distance = distance;
    }
    setCurve(curve) {
        this.path = curve.path;
        this.curve = curve;
        this.segment = undefined;
        this.segment1 = curve.segment1;
        this.segment2 = curve.segment2;
    }
    getIndex() {
        return this.curve && this.curve.getIndex();
    }
    getOffset() {
        if (this.offset === undefined) {
            let _offset = 0;
            const path = this.getPath();
            const index = this.getIndex();
            if (path && index) {
                const curves = path.getCurves();
                for (let i = 0; i < index; i++)
                    _offset += curves[i].getLength();
            }
            this.offset = _offset;
        }
        return this.offset;
    }
    getPath() {
        return this.curve && this.curve.path;
    }
}
//# sourceMappingURL=curve_location.js.map